import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, UntypedFormGroup, Validators } from '@angular/forms';
import { IInscription, IValidation } from 'src/app/models/inscription.model';
import { IPersonne } from 'src/app/models/personne.model';
import * as _ from 'lodash';
import moment from 'moment';
import { EGenre } from 'src/app/enumerations/genre.enum';
import { IEnumResponse } from 'src/app/models/enumeration.model';
import { Message, MessageService } from 'primeng/api';
import { CommonService } from 'src/app/services/common.service';
import { PersonneService } from 'src/app/services/personne.service';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AccepteOffreConditionComponent } from '../accepte-offre-condition/accepte-offre-condition.component';
import { IAdress } from 'src/app/models/adress.model';
import { AdressService } from 'src/app/services/adress.service';
import { SiteService } from 'src/app/services/site.service';
import { IService } from 'src/app/models/service.model';
import { IPeriodicite } from 'src/app/models/periodicite.model';
import { PeriodiciteService } from 'src/app/services/periodicite.service';
import { IPersonneTmp } from 'src/app/models/personne-tmp.model';
import { IBlocInscription } from 'src/app/models/bloc-inscription.model';
import { AnneeService } from 'src/app/services/annee.service';
import { InscriptionService } from 'src/app/services/inscription.service';
import { ETypePersonnePhysique } from 'src/app/enumerations/type-personne.enum';

interface ILANCER {
  object: IPeriodicite;
  adresses: IAdress[];
}
@Component({
  selector: 'app-fill-student',
  templateUrl: './fill-student.component.html',
  styleUrls: ['./fill-student.component.scss'],
  providers: [DialogService, MessageService]
})
export class FillStudentComponent implements OnInit, OnDestroy {
  sites: IService[] = [];
  siteSelected: IService;
  loadingOffre = false;

  genres: any[] = [];
  genreSelected: any = _.stubObject();
  enumGenre = EGenre;

  countries: any[] = [];
  countrySelected: any;

  form: FormGroup;
  formSubmitted = false;

  ref: DynamicDialogRef;

  enumPersonne = ETypePersonnePhysique;
  lancer: ILANCER[] = [];
  apprenant: IPersonne = _.stubObject();
  apprenantTmp: IPersonneTmp = _.stubObject();
  responsable: IPersonneTmp = _.stubObject();
  inscriptions: IInscription[] = [];
  global: IValidation = _.stubObject();
  bloc: IBlocInscription = _.stubObject();
  oldStudent = false;
  // oldStudent: string = 'no';
  findStudent = true;
  searchLoading = false;

  messagesStudent: Message[] | undefined;
  messagesSite: Message[] | undefined;
  messagesGeneral: Message[] | undefined;

  constructor(
    private formBuilder: FormBuilder,
    private personneService: PersonneService,
    private siteService: SiteService,
    private periodiciteService: PeriodiciteService,
    private adressService: AdressService,
    private inscriptionService: InscriptionService,
    private anneeService: AnneeService,
    private readonly enumService: CommonService,
    private messageService: MessageService,
    private dialogService: DialogService
  ) {}

  ngOnInit(): void {
    this.messagesStudent = [{ severity: 'error', detail: 'Un problème est survenu. Veuillez renseigner les informations le concernant ou contacter directement le centre au +229 97 213 717' }];
    this.messagesSite = [{ severity: 'info', summary: 'Offre indisponible', detail: 'Aucune offre disponible pour le moment sur ce site' }];
    this.messageService.add({
      severity: 'success',
      detail: 'Votre inscription à été bien prise en compte',
      closable: false,
    });

    this.enumService.getCountry().subscribe(data => {
      this.countries = data;
    })

    this.inscriptions = [];

    this.form = this.formBuilder.group({
      reference: [''],
      nom: ['', Validators.required],
      prenom: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      telephone: [''],
      dateNaissance: [new Date(), Validators.required],
      genre: ['', Validators.required],
      parent: this.formBuilder.group({
        nom: ['', Validators.required],
        prenom: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]],
        telephone: [''],
        dateNaissance: [new Date(), Validators.required],
        adresse: ['', Validators.required],
        genre: ['', Validators.required]
      })
    });

    this.getGenres();
    this.getSites();
  }

  get typeDocumentPersonneCheckForm() {
    return this.form.controls;
  }

  getGenres(): void {
    this.enumService.getGenreEnum().subscribe((response: IEnumResponse) => {
      this.genres = response.objects;
      this.genreSelected = response.objects[0];
    });
  }

  getSites(): void {
    this.siteService.gets().subscribe(response => {
      this.sites = response.objects;
    });
  }

  // addPersonne(): void {
  //   this.personneService.create(this.apprenant).subscribe((response: IPersonneResponse) => {
  //     this.messageService.add({
  //       severity: 'success',
  //       detail: 'Votre inscription à été bien prise en compte',
  //       closable: false,
  //     });
  //   });
  // }

  // fillObject(): void {
  //   in
  // }

  //Charger offre en fonction du site
  async changeWebsite(e: any): Promise<void> {
    this.lancer = [];
    this.loadingOffre = true;
    console.log(this.siteSelected);
    console.log(e.value);
    this.periodiciteService.getByService(e.value.id).subscribe(response => {
      const responsePeriodicite = response.objects;
      console.log(responsePeriodicite);

      if (responsePeriodicite.length !== 0) {
        const system = new Date();
        responsePeriodicite.forEach(async element => {
          if (!element.prive) {
            // en cours
            if(moment(element.dateDebut).isSameOrBefore(system) && moment(element.dateFin).isSameOrAfter(system)) {
              console.log('oui');
              const responseAdresses = await this.adressService.getAll(element.offreService.service.id).toPromise();
              this.lancer.push(
                {
                  object: element,
                  adresses: responseAdresses.objects
                }
              );
              
              // this.launchedOffres.push(element);
            }
    
            // a venir
            if(moment(element.dateDebut).isAfter(system)) {
              console.log('oui oui');
              // this.launchedOffres.push(element);
              const responseAdresses = await this.adressService.getAll(element.offreService.service.id).toPromise();
              this.lancer.push(
                {
                  object: element,
                  adresses: responseAdresses.objects
                }
              );
            }
          }
        });
      }
      
      // responsePeriodicite.forEach((async element => {
      //   console.log(element);
        
      //   if (element.prive) {
      //     const responseAdresses = await this.adressService.getAll(element.offreService.service.id).toPromise();
      //     this.lancer.push(
      //       {
      //         object: element,
      //         adresses: responseAdresses.objects
      //       }
      //     );
      //   }
      // }));
      console.log(this.lancer);

      this.loadingOffre = false;
    });
    
    
  }

  showCondition(offre: IPeriodicite): void {
    this.ref = this.dialogService.open(AccepteOffreConditionComponent, {
      header: 'Approbation condition',
      width: '40%',
      contentStyle: { overflow: 'auto', boxShadow: 'none' },
      baseZIndex: 100000,
      // maximizable: true,
      data: {
        lancement: offre
      }
    });

    this.ref.onClose.subscribe((result: any) => {
      console.log(result);
      if (result.contrat) {
        this.addInscriptionInGlobal(result.selection);
        this.messageService.add({ severity: 'info', summary: 'Product Selected', detail: 'product.name '});
      }
      console.log(this.global);
      
    });
  }

  // Recherche etudiant en fonction du matricule
  searchStudent(e: string): void {
    console.log(e);
    this.apprenant = _.stubObject();
    // this.findStudent = false;
    if(e.length !== 0) {
      this.searchLoading = true;
      // const foundPersonne = (await this.personneService.getByMatricule('%23'+e).toPromise()).object;
      // foundPersonne?this.findStudent=true:this.findStudent=false;
      // // if (result.success) {
      // // }
      // this.apprenant = foundPersonne;
      // this.searchLoading = false;

      this.personneService.getByMatricule('%23'+e).subscribe(response => {
        console.log(response);
        response.success?this.findStudent=true:this.findStudent=false;
        if (response.success) {
          this.apprenant = response.object;
        }
        this.searchLoading = false;
      });
      
    }
  }

  // Ajout des offres dans une liste globale
  async addInscriptionInGlobal(object: IPeriodicite): Promise<void> {
    let inscription: IInscription = _.stubObject();
    inscription.periodicite = object; 
    this.inscriptions.push(inscription);
  }

  passCheckFormVerification(): boolean {
    if((this.form.value.nom !== '' || this.form.value.nom !== null) &&
     (this.form.value.prenom !== '' || this.form.value.prenom !== null)) {
      return true;
     }
    return false;
  }

  async onSubmit(): Promise<void> {
    console.log(this.form.value);
    console.log(this.apprenantTmp);
    console.log(this.oldStudent);

    this.bloc = _.stubObject();
    this.apprenantTmp = _.stubObject();
    this.global = _.stubObject();
    
    if(!this.oldStudent) {
      if(!this.passCheckFormVerification()) {
        this.messagesGeneral = [{ severity: 'info', summary: 'Incomplet', detail: 'Renseignez le nom, le prénom et la date de naissance de l\'apprenant' }];
        return;
      }
      if (this.inscriptions.length === 0) {
        this.messagesGeneral = [{ severity: 'info', summary: 'Incomplet', detail: 'Choisissez au moins une offre' }];
        return;
      }
      this.apprenantTmp.nom = this.form.value.nom;
      this.apprenantTmp.prenom = this.form.value.prenom;
      this.apprenantTmp.dateNaissance = this.form.value.dateNaissance;
      this.apprenantTmp.telephone = this.form.value.telephone;
      this.apprenantTmp.email = this.form.value.email;
      this.apprenantTmp.genre = this.form.value.genre.value;
      this.apprenantTmp.typePersonnePhysique = this.enumPersonne.ETUDIANT;
      this.apprenantTmp.dateDemande = new Date();
      this.apprenantTmp.valider = false;
    
      this.responsable.nom = this.form.value.parent.nom;
      this.responsable.prenom = this.form.value.parent.prenom;
      this.responsable.dateNaissance = this.form.value.parent.dateNaissance;
      this.responsable.telephone = this.form.value.parent.telephone;
      this.responsable.email = this.form.value.parent.email;
      this.responsable.genre = this.form.value.parent.genre.value;
      this.responsable.typePersonnePhysique = this.enumPersonne.PARENT;
      this.responsable.dateDemande = new Date();
      this.responsable.valider = false;

      this.bloc.reInscription = false;
      this.bloc.forfait = (await this.inscriptionService.getActif().toPromise()).object;
      this.bloc.eleveTmp = this.apprenantTmp;
      this.bloc.responsableEleveTmp = this.responsable;

      this.global.blocInscriptionDTO = this.bloc;
      this.global.inscriptionList = this.inscriptions;
    } else {
      if (this.findStudent) {
        this.bloc.reInscription = true;
        this.bloc.eleve = this.apprenant;

        this.global.blocInscriptionDTO = this.bloc;
        this.global.inscriptionList = this.inscriptions;
      } else {
        this.messagesGeneral = [{ severity: 'info', summary: 'Vérification', detail: 'Veuillez renseigner un numéro d\'identification correct' }];
        return;
      }
    }

    // const cace = (await this.personneService.getCenter().toPromise()).object;

    console.log(this.global);
    const g = await this.inscriptionService.create(this.global).toPromise();
    console.log('result', g);
    if(!g.success) {
      this.messagesGeneral = [{ severity: 'error', summary: 'Information', detail: g.message }];
    }
    
    // this.dialogService.
  }

  // async validate(): Promise<void> {
  //   console.log(this.validApprenant);


  //   if (this.newStudent) { 
  //     this.personnePhysiqueFormSubmitted = true;
  //     if(this.personnePhysiqueForm.invalid) {
  //       this.messageService.add({
  //         key: "tc",
  //         severity: "info",
  //         summary: "Information",
  //         detail: 'Renseignez les informations obligatoire',
  //       });
  //       return;
  //     }
  //     if(this.inscriptionTmp.length === 0) {
  //       this.messageService.add({
  //         key: "tc",
  //         severity: "info",
  //         summary: "Information",
  //         detail: 'Choisissez au moins une offre',
  //       });
  //       return;
  //     }

  //     const tmp: IPersonnePhysiqueTmp = _.stubObject();
  //     tmp.nom = this.personnePhysiqueForm.value.nom;
  //     tmp.prenom = this.personnePhysiqueForm.value.prenom;
  //     tmp.dateNaissance = this.personnePhysiqueForm.value.date;
  //     tmp.genre = this.genreSelected.value;
  //     tmp.email = this.personnePhysiqueForm.value.email;
  //     tmp.telephone = this.personnePhysiqueForm.value.telephone;
  //     tmp.typePersonnePhysique = this.enumTypePersonne.ETUDIANT;
      
  //     const response = await this.personneTmpService.create(tmp).toPromise();
  //     console.log(response);
  //     this.apprenantCreated = response.objects[0];
  //     // this.apprenantCreated = tmp;

  //     // console.log(this.apprenantCreated);
      
 
  //   } else {
  //     if (!this.validApprenant) {
  //       this.messageService.add({
  //         key: "tc",
  //         severity: "info",
  //         summary: "Information",
  //         detail: 'Valider l\'apprenant',
  //       });
  //       return;
  //     }

  //     if(this.inscriptionTmp.length === 0) {
  //       this.messageService.add({
  //         key: "tc",
  //         severity: "info",
  //         summary: "Information",
  //         detail: 'Choisissez au moins une offre',
  //       });
  //       return;
  //     }
  //   }

  //   let bloc: IBlocInscription = _.stubObject();
  //   bloc.forfait = (await this.forfaitService.getActif(ETypeForfait.FORFAIT_PARTENAIRE).toPromise()).object;
  //   this.newStudent?bloc.eleveTmp=this.apprenantCreated:bloc.eleve=this.apprenantSelected;
  //   this.newStudent?bloc.reInscription=false:bloc.reInscription=true;
  //   bloc.partenaire = (await this.personneService.getOne(6).toPromise()).object;

  //   console.log(bloc);
    
  //   this.inscription.blocInscriptionDTO = bloc;
  //   this.inscription.inscriptionList = this.inscriptionTmp;

  //   console.log(this.inscription);

  //   const responseInscription = await this.inscriptionService.createFromOutSide(this.inscription).toPromise();
  //   console.log(responseInscription);

  //   this.messageService.add({
  //     key: "tc",
  //     severity: "success",
  //     summary: "Information",
  //     detail: 'Inscription envoyée',
  //   });

  //   this.activeModal.close();
  // }

  ngOnDestroy() {
    if (this.ref) {
        this.ref.close();
    }
  }

}
